module.exports = __webpack_public_path__ + "static/img/slider66.e743fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider66.png
// module id = 2Qha
// module chunks = 1